<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
          <li>
            <router-link :to="{name: 'Edit Profile'}" tag="a">
              <i class="fas fa-arrow-circle-up"></i> Profile
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'Credits', params: {buy: true}}" tag="a">
              <i class="fas fa-arrow-circle-up"></i> Buy credits
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'Fileservice', params: {upload: true}}" tag="a">
              <i class="fas fa-arrow-circle-up"></i> Upload file
            </router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright pull-right">
        
        &copy; <a
         :href="ws.getSetting('domain')">
          {{ ws.getSetting('name') }}
      </a>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    computed: {
      ws: () => { return Webservice; }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue